import { gql } from 'apollo-angular';
import { Tour } from '../../shared/entities/tour';

export const TOUR_PLANNER_TOURS_QUERY = gql`
query GetDailyToursQuery(
  $locationId: UUID,
  $states:[TourState],
  $fromDateTime: String,
  $toDateTime: String
)
{
  dailyTours: getTours(
    filter: {
      locationId: $locationId,
      states: $states,
      fromDateTime: $fromDateTime,
      toDateTime: $toDateTime
  }
  ){
    ...tourExcerpt
  }
}
fragment tourExcerpt on Tour{
  id
  name
  scheduledDepartureDateTime
  scheduledArrivalDateTime
  actualDepartureDateTime
  actualArrivalDateTime
  dateTimeReference
  state
  note
  driver{
    id
    firstName
    lastName
  }
  resource {
    id
    name
  }
  tasks{
    id
    type
    number
    taskType {
      code
      name
      prefix
      icon
      color
    }
    color
    fileCount
    commentCount
    noteCount
    dueDateTimePeriod {
      modifier
      dateTime
      fromDateTime
      toDateTime
      precision
    }
    state
    title
    description
    commands(commandInputs: [
      { name: "updateDefaultTaskCommand" },
      { name: "deleteDefaultTaskCommand" }
    ])
    order{
      id
      number
      note
      commentCount
      fileCount
      customer {
        type
        companyName
        companyNameExtension
        firstName
        lastName
      }
    }
    address {
      id
      street
      houseNumber
      postalCode
      city
      country
      geocodingResultGrade
      name
      note
      lat
      lng
      text
      type
      note
      externalAddress
    }
    linkedContacts: linkedEntities(entityType: "Contact") {
      linkId
      linkType
      linkLabel
      perspective
      role
      linkedEntity {
        ... on Contact {
          id
          type
          number
          companyName
          companyNameExtension
          firstName
          lastName
        }
      }
    }
  }
  effectiveArrivalDateTime
  effectiveDepartureDateTime
  commands(commandInputs: [
    { name: "tourDeleteCommand" },
    { name: "tourUpdateCommand" },
    { name: "tourFinishCommand" }
  ])
}
`;

export interface TourPlannerToursQueryResponse {
  dailyTours: Tour[];
}